import React from "react";
import { Link } from 'react-router-dom'
import { ROUTING_APP_1, ROUTING_APP_2, ROUTING_LOGIN } from '../../constants/routing'
import { NAME_APP1, NAME_APP2 } from '../../constants/wording'

function Application({ to, label, children }) {
  return (
    <Link to={to}>
      <div className="card">
        <div className="card-content">
          <div className="card-title">
            {label}
          </div>
          <p className="home-card-content">{ children }</p>
        </div>
      </div>
    </Link>
  )
}

function Home() {
  return (
    <div className="row">
      <div className="col s6">
        <Application to={"/" + ROUTING_APP_1 + "/" + ROUTING_LOGIN} label={NAME_APP1}>
          Proposez grâce à des données contextualisées des offres de services pertinentes aux clients ayant besoin d'une assistance.
        </Application>
      </div>
      <div className="col s6">
        <Application to={"/" + ROUTING_APP_2 + "/" + ROUTING_LOGIN} label={NAME_APP2}>
          Découvrez les offres les plus pertinentes pour vos clients grâce un moteur de recommandation amélioré en permance par de nouvelles datas.
        </Application>
      </div>
    </div>
  )
}

export default Home;